<div id="auth-error-container" class="message-card">
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="40.0002" y="30.9998" width="16" height="50" fill="white" />
    <mask
      id="mask0_266_356"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="-1"
      width="96"
      height="97"
    >
      <rect y="-0.000244141" width="96" height="96" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_266_356)">
      <path
        d="M12.4632 81.9998C11.8929 81.9998 11.3911 81.8658 10.9577 81.5978C10.5242 81.3298 10.1871 80.9766 9.94627 80.5382C9.68987 80.1341 9.54887 79.6792 9.52327 79.1736C9.4976 78.6679 9.63653 78.1608 9.94007 77.6524L45.5289 16.2966C45.8275 15.822 46.187 15.4681 46.6076 15.2348C47.0281 15.0014 47.4922 14.8848 47.9999 14.8848C48.5075 14.8848 48.9716 15.0014 49.3922 15.2348C49.8127 15.4681 50.1723 15.822 50.4709 16.2966L86.0597 77.6524C86.3632 78.1608 86.5022 78.6679 86.4766 79.1736C86.4509 79.6792 86.3099 80.1341 86.0535 80.5382C85.8127 80.9766 85.4755 81.3298 85.0421 81.5978C84.6087 81.8658 84.1068 81.9998 83.5366 81.9998H12.4632ZM48.3027 71.4537C49.0162 71.4537 49.6082 71.2123 50.0787 70.7297C50.5492 70.247 50.7845 69.6489 50.7845 68.9355C50.7845 68.222 50.5431 67.63 50.0605 67.1595C49.5778 66.689 48.9797 66.4538 48.2663 66.4538C47.5528 66.4538 46.9608 66.6951 46.4903 67.1777C46.0197 67.6603 45.7845 68.2584 45.7845 68.9719C45.7845 69.6854 46.0258 70.2774 46.5085 70.7479C46.9911 71.2184 47.5892 71.4537 48.3027 71.4537ZM48.3041 61.6615C48.9525 61.6615 49.4896 61.444 49.9152 61.0091C50.3408 60.5741 50.5537 60.0352 50.5537 59.3923V42.1461C50.5537 41.5031 50.3343 40.9642 49.8957 40.5293C49.457 40.0943 48.9134 39.8769 48.2649 39.8769C47.6164 39.8769 47.0794 40.0943 46.6538 40.5293C46.2281 40.9642 46.0153 41.5031 46.0153 42.1461V59.3923C46.0153 60.0352 46.2346 60.5741 46.6733 61.0091C47.112 61.444 47.6556 61.6615 48.3041 61.6615Z"
        fill="#E8002A"
      />
    </g>
  </svg>

  @if (isSessionError) {
    <span class="title" i18n="@@AuthenticationErrorTitle"> Error de autenticación </span>
    <span class="description" i18n="@@AuthenticationErrorDescription">
      La sesión expiró, vuelva a abrir Portfolio Monitor desde la pantalla de productos Commerce
      Platform.
    </span>
  } @else if (isEtmAccountInactive) {
    <span class="title" i18n="@@etmAccountInactiveTitle"> Contrato inactivo </span>
    <span class="description" i18n="@@etmAccountInactiveDescription">
      No fue posible acceder a la plataforma. Identificamos que el contrato de su empresa con
      Equifax no está activo. Por favor, póngase en contacto con su Administrador o con el soporte
      de Equifax.
    </span>
  } @else if (isProductEntitlementInactive) {
    <span class="title" i18n="@@productEntitlementInactiveTitle"> Producto no habilitado </span>
    <span class="description" i18n="@@productEntitlementInactiveDescription">
      Su cuenta está activa, pero el producto Portfolio no está habilitado para su usuario. Si
      necesita acceso, póngase en contacto con el Administrador de su cuenta o hable con nuestro
      soporte.
    </span>
  } @else {
    <span class="title" i18n="@@loginErrorTitle"> Error al iniciar sesión </span>
    <span class="description" i18n="@@loginErrorDescription">
      Encontramos un error relacionado con su inicio de sesión en la plataforma. Serás redirigido a
      la pantalla de productos de Comercio.
    </span>
  }

  <button
    id="auth-error-btn-voltar"
    class="go-commerce-button"
    i18n="@@backToCommerce"
    (click)="goToCommerce()"
  >
    Volver a Commerce
  </button>
</div>
